import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";

import './RichiediSpurghiCase.scss';

const RichiediSpurghiCase = () => (
  <div className="RichiediSpurghiCase" data-testid="RichiediSpurghiCase">
    <CaseGenerator type={CaseForms.RichiediSpurghiCase} />
  </div>
);

export default RichiediSpurghiCase;
